// Location data processing utilities
import allCountries from "./AllCountries"
import geoInfo from "./geoInfo"

interface LocationDataItem {
  country: string
  region: string
  province: string
}

// Lazy load location data to avoid initialization issues
let locationData: LocationDataItem[] | null = null

const getLocationData = (): LocationDataItem[] => {
  if (!locationData) {
    try {
      locationData = [
        ...geoInfo.map(item => ({
          country: "Afghanistan",
          region: item.region_name,
          province: item.province
        })),
        ...allCountries.map(item => ({
          country: item.Country,
          region: item.Region,
          province: item.Province
        }))
      ]
    } catch (error) {
      console.error('Error loading location data:', error)
      locationData = []
    }
  }
  return locationData
}


export const getUniqueCountries = (): Array<{ id: string; name: string }> => {
  const data = getLocationData()
  const uniqueCountries = [...new Set(data.map((item) => item.country))]
  return uniqueCountries.map((country) => ({
    id: country,
    name: country,
  }))
}

export const getUniqueRegions = (countryName?: string): Array<{ id: string; name: string }> => {
  const data = getLocationData()
  let filteredData = data

  if (countryName) {
    filteredData = data.filter((item) => item.country === countryName)
  }

  const uniqueRegions = [...new Set(filteredData.map((item) => item.region))]
  return uniqueRegions.map((region) => ({
    id: region,
    name: region,
  }))
}

export const getUniqueProvinces = (countryName?: string, regionName?: string): Array<{ id: string; name: string }> => {
  const data = getLocationData()
  let filteredData = data

  if (countryName) {
    filteredData = filteredData.filter((item) => item.country === countryName)
  }

  if (regionName) {
    filteredData = filteredData.filter((item) => item.region === regionName)
  }

  const uniqueProvinces = [...new Set(filteredData.map((item) => item.province))]
  return uniqueProvinces.map((province) => ({
    id: province,
    name: province,
  }))
}

// Get all unique values for initial load
export const getAllLocationData = () => {
  try {
    return {
      countries: getUniqueCountries(),
      regions: getUniqueRegions(),
      provinces: getUniqueProvinces(),
    }
  } catch (error) {
    console.error('Error getting location data:', error)
    return {
      countries: [],
      regions: [],
      provinces: [],
    }
  }
}
